import t from "@ext/localization/locale/translate";
import { useScrollToNextComment } from "@ext/markdown/elements/comment/edit/logic/hooks/useScrollToNextComment";
import { Divider } from "@ui-kit/Divider";
import { FloatingIconButton } from "@ui-kit/FloatingPanel";
import { GlassPanelHeader } from "@ui-kit/GlassPanel";

interface CommentHeaderProps {
	commentId: string;
	onClose: () => void;
	onResolve: () => void;
	renderDeleteIcon: boolean;
}

export const CommentHeader = (props: CommentHeaderProps) => {
	const { commentId, onClose, onResolve, renderDeleteIcon } = props;
	const { nextScroll, prevScroll } = useScrollToNextComment(commentId);

	return (
		<GlassPanelHeader
			actions={
				<>
					<FloatingIconButton
						aria-label={t("comments.move.up")}
						disabled={!prevScroll}
						icon="chevron-up"
						iconClassName="size-3.5 shrink-0"
						onClick={prevScroll}
						size="md"
						tooltip={t("comments.move.up")}
					/>
					<FloatingIconButton
						aria-label={t("comments.move.down")}
						disabled={!nextScroll}
						icon="chevron-down"
						iconClassName="size-3.5 shrink-0"
						onClick={nextScroll}
						size="md"
						tooltip={t("comments.move.down")}
					/>
					{renderDeleteIcon && (
						<>
							<Divider className="mx-2.5 h-4 bg-alpha-high-90" orientation="vertical" />
							<FloatingIconButton
								aria-label={t("delete-as-resolved")}
								icon="big-check2"
								iconClassName="size-3.5 shrink-0"
								onClick={onResolve}
								size="md"
								tooltip={t("delete-as-resolved")}
							/>
						</>
					)}
				</>
			}
			onClose={onClose}
			title={t("comment")}
		/>
	);
};
